import { render, staticRenderFns } from "./CategoriesMobile.vue?vue&type=template&id=3421f304&scoped=true&"
import script from "./CategoriesMobile.vue?vue&type=script&lang=js&"
export * from "./CategoriesMobile.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesMobile.vue?vue&type=style&index=0&id=3421f304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3421f304",
  null
  
)

export default component.exports